module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/assessment_achievements/3_9eec0fb6b8817303ae210bc3a9206789.png";